/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 시스템 설정 정보 조회 (프로모션 등)
 */
export const authSessionControllerGetSystemConfigResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        proTrialEnabled: zod
          .boolean()
          .describe("PRO 플랜 1개월 무료 체험 활성화 여부"),
        proTrialDays: zod.number().describe("무료 체험 일수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 사용자 로그인 (Bearer Token - Response Body 반환)
 */
export const authSessionControllerLoginBodyUserIdMin = 3;

export const authSessionControllerLoginBodyPasswordMin = 6;

export const authSessionControllerLoginBodyRememberMeDefault = false;

export const authSessionControllerLoginBody = zod
  .object({
    userId: zod
      .string()
      .min(authSessionControllerLoginBodyUserIdMin)
      .describe("사용자 ID 또는 이메일"),
    password: zod
      .string()
      .min(authSessionControllerLoginBodyPasswordMin)
      .describe("사용자 비밀번호"),
    rememberMe: zod
      .boolean()
      .default(authSessionControllerLoginBodyRememberMeDefault)
      .describe("로그인 상태 유지 여부"),
  })
  .strict();

/**
 * 회원가입 성공 시 Access Token과 Refresh Token을 반환합니다.
 * @summary 회원가입 (Bearer Token 반환)
 */
export const authSessionControllerSignupBodyUserIdMin = 4;
export const authSessionControllerSignupBodyUserIdMax = 50;

export const authSessionControllerSignupBodyUserIdRegExp = new RegExp(
  "^[a-zA-Z0-9_-]+$",
);
export const authSessionControllerSignupBodyPasswordMin = 8;
export const authSessionControllerSignupBodyPasswordMax = 64;

export const authSessionControllerSignupBodyPasswordRegExp = new RegExp(
  "^(?=.*[a-z])(?=.*\\d)(?=.*[!$%&*?@])[a-zA-Z\\d!$%&*?@]+$",
);
export const authSessionControllerSignupBodyNiceDataOneNameMax = 50;

export const authSessionControllerSignupBodyNiceDataOneBirthDateRegExp =
  new RegExp("^[0-9]{8}$");
export const authSessionControllerSignupBodyNiceDataOnePhoneRegExp = new RegExp(
  "^0(?:[1][0-9]|[2-9]\\d?)-?\\d{3,4}-?\\d{4}$",
);

export const authSessionControllerSignupBody = zod
  .object({
    userId: zod
      .string()
      .min(authSessionControllerSignupBodyUserIdMin)
      .max(authSessionControllerSignupBodyUserIdMax)
      .regex(authSessionControllerSignupBodyUserIdRegExp)
      .describe(
        "사용자 ID - 로그인용 고유 식별자 (4-50자, 영문/숫자/_/- 만 허용)",
      ),
    password: zod
      .string()
      .min(authSessionControllerSignupBodyPasswordMin)
      .max(authSessionControllerSignupBodyPasswordMax)
      .regex(authSessionControllerSignupBodyPasswordRegExp)
      .describe(
        "비밀번호 - 8자 이상 64자 이하, 영문 소문자·숫자·특수문자(!$%&*?@) 각 1자 이상",
      ),
    niceData: zod
      .object({
        ciHash: zod
          .string()
          .describe("NICE CI 해시값 - 중복가입 방지용 고유 식별자"),
        diHash: zod
          .string()
          .describe("NICE DI 해시값 - 서비스별 중복가입 확인용 식별자"),
        name: zod
          .string()
          .max(authSessionControllerSignupBodyNiceDataOneNameMax)
          .describe("실명 - NICE 본인인증에서 확인된 이름"),
        birthDate: zod
          .string()
          .regex(authSessionControllerSignupBodyNiceDataOneBirthDateRegExp)
          .describe(
            "생년월일 - NICE 인증에서 확인된 8자리 생년월일 (YYYYMMDD)",
          ),
        gender: zod
          .enum(["M", "F", "O"])
          .describe("성별 - NICE 인증에서 확인된 성별")
          .describe("성별 - NICE 인증에서 확인된 성별"),
        phone: zod
          .string()
          .regex(authSessionControllerSignupBodyNiceDataOnePhoneRegExp)
          .describe(
            "휴대폰 번호 - NICE 인증에서 확인된 휴대폰 번호 (하이픈 있거나 없음)",
          ),
      })
      .strict()
      .describe("NICE 본인인증 데이터 - 인증 완료 후 받은 사용자 정보"),
    verificationRequestNo: zod
      .string()
      .describe(
        "검증 완료된 NICE 인증 요청 번호 (POST /auth/nice/callback 응답의 requestNo)",
      ),
    terms: zod
      .array(
        zod
          .object({
            type: zod
              .enum(["terms", "privacy", "marketing"])
              .describe(
                "약관 타입 - terms: 이용약관(필수), privacy: 개인정보처리방침(필수), marketing: 마케팅수신(선택)",
              ),
            agreed: zod
              .boolean()
              .describe(
                "약관 동의 여부 - terms와 privacy는 필수(true), marketing은 선택",
              ),
            version: zod.string().describe("약관 버전"),
          })
          .strict(),
      )
      .describe(
        "약관 동의 목록 - terms와 privacy는 필수 동의, marketing은 선택 동의",
      ),
  })
  .strict();

/**
 * @summary 토큰 갱신 (Refresh Token Body 전송)
 */
export const authSessionControllerRefreshBody = zod
  .object({
    refreshToken: zod.string().describe("Refresh Token"),
  })
  .strict();

/**
 * @summary 현재 사용자 정보 조회
 */
export const authSessionControllerGetCurrentUserResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("내부 사용자 ID (UUID)"),
        userId: zod
          .string()
          .optional()
          .describe("사용자가 입력한 ID (username)"),
        authId: zod.string().optional().describe("Supabase Auth ID"),
        contactEmail: zod.string().describe("사용자 연락처 이메일"),
        name: zod.string().optional().describe("사용자 성명"),
        phone: zod.string().optional().describe("사용자 전화번호"),
        profileImageUrl: zod.string().nullish().describe("프로필 이미지 URL"),
        emailVerified: zod.boolean().optional().describe("이메일 인증 여부"),
        niceVerifiedAt: zod
          .string()
          .nullish()
          .describe("NICE 본인인증 완료 날짜 (ISO 8601 형식)"),
        userType: zod
          .enum(["buyer", "supplier", "admin"])
          .optional()
          .describe(
            "사용자 타입 (buyer: 구매자, supplier: 공급자, admin: 관리자)",
          ),
        isMaster: zod
          .boolean()
          .optional()
          .describe("마스터 관리자 여부 (관리자 계정일 때만 제공)"),
        createdAt: zod
          .string()
          .optional()
          .describe("사용자 생성 날짜 (ISO 8601 형식)"),
        defaultAddress: zod
          .object({
            id: zod.string().describe("주소 ID (UUID)"),
            userId: zod.string().describe("사용자 ID (UUID)"),
            label: zod
              .string()
              .optional()
              .describe("주소 라벨 (회사, 집, 창고 등)"),
            isDefault: zod.boolean().describe("기본 배송지 여부"),
            postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
            province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
            city: zod.string().describe("시/군/구 (기초자치단체)"),
            district: zod.string().optional().describe("읍/면/동 (선택사항)"),
            streetAddress: zod.string().describe("도로명 주소"),
            addressDetail: zod
              .string()
              .optional()
              .describe("상세 주소 (건물명, 동/호 등)"),
            recipientName: zod.string().optional().describe("수령인 이름"),
            recipientPhone: zod
              .string()
              .optional()
              .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
            createdAt: zod
              .string()
              .optional()
              .describe("생성일 (ISO 8601 형식)"),
            updatedAt: zod
              .string()
              .optional()
              .describe("수정일 (ISO 8601 형식)"),
          })
          .strict()
          .nullish()
          .describe("기본 배송지 정보"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 최신 약관 목록 조회
 */
export const authSessionControllerGetLatestTermsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            type: zod.string(),
            version: zod.string(),
            title: zod.string(),
            content: zod.string(),
            isRequired: zod.boolean(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 비밀번호 변경 (현재 비밀번호 검증, 새 비밀번호 달라야 함)
 */
export const authPasswordControllerChangePasswordBody = zod
  .object({
    currentPassword: zod.string().describe("현재 비밀번호"),
    newPassword: zod.string().describe("새로운 비밀번호"),
  })
  .strict();

export const authPasswordControllerChangePasswordResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * NICE 본인인증으로 받은 CI Hash를 검증하고, 검증 성공 시 15분 유효한 password-reset JWT 토큰을 발급합니다.
 * @summary CI Hash 검증 및 비밀번호 재설정 토큰 발급 (Step 1, 분당 5회 제한)
 */
export const authPasswordControllerVerifyCiHashBody = zod
  .object({
    userId: zod.string().describe("사용자 ID"),
    ciHash: zod.string().describe("NICE 본인인증으로 받은 CI Hash"),
    requestNo: zod.string().describe("이번 재설정에서 한 NICE 본인인증의 요청번호"),
  })
  .strict();

export const authPasswordControllerVerifyCiHashResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("API 호출 성공 여부"),
        message: zod.string().describe("작업 성공 메시지"),
        data: zod
          .object({
            success: zod.boolean().describe("검증 성공 여부"),
            resetToken: zod
              .string()
              .describe("비밀번호 재설정용 임시 토큰 (15분 유효)"),
          })
          .strict()
          .describe("CI Hash 검증 응답 데이터"),
        timestamp: zod
          .string()
          .datetime({})
          .describe("응답 생성 시각 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * Step 1에서 받은 password-reset JWT 토큰으로 비밀번호를 변경합니다.
 * @summary 비밀번호 재설정 완료 (resetToken + 새 비밀번호) (Step 2, 분당 5회 제한)
 */
export const authPasswordControllerConfirmPasswordResetBody = zod
  .object({
    resetToken: zod.string().describe("CI Hash 검증 시 받은 재설정 토큰"),
    newPassword: zod.string().describe("새 비밀번호 (최소 8자)"),
  })
  .strict();

export const authPasswordControllerConfirmPasswordResetResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("API 호출 성공 여부"),
        message: zod.string().describe("작업 성공 메시지"),
        data: zod
          .object({
            message: zod.string().describe("비밀번호 변경 완료 메시지"),
          })
          .strict()
          .describe("비밀번호 변경 응답 데이터"),
        timestamp: zod
          .string()
          .datetime({})
          .describe("응답 생성 시각 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 사용자 ID 찾기 (이름+휴대폰, 마스킹된 ID 반환, 분당 5회 제한)
 */
export const authIdentityControllerFindUserIdBodyNameMax = 50;

export const authIdentityControllerFindUserIdBodyPhoneRegExp = new RegExp(
  "^0(?:[1][0-9]|[2-9]\\\\d?)-?\\\\d{3,4}-?\\\\d{4}$",
);

export const authIdentityControllerFindUserIdBody = zod
  .object({
    name: zod
      .string()
      .max(authIdentityControllerFindUserIdBodyNameMax)
      .describe("사용자 실명 - 회원가입 시 입력한 이름"),
    phone: zod
      .string()
      .regex(authIdentityControllerFindUserIdBodyPhoneRegExp)
      .describe("휴대폰 번호 - 하이픈 있거나 없음"),
  })
  .strict();

export const authIdentityControllerFindUserIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        exists: zod
          .boolean()
          .describe("사용자 존재 여부 - true면 userId 포함, false면 null"),
        userId: zod
          .string()
          .nullable()
          .describe(
            "사용자 비즈니스 ID (user_id) - 영문/숫자/언더스코어 형식 (exists가 false면 null)",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 사용자 ID 중복 확인 (분당 10회 제한)
 */
export const authIdentityControllerCheckUserIdAvailabilityBody = zod
  .object({
    userId: zod.string().describe("사용자 ID"),
  })
  .strict();

export const authIdentityControllerCheckUserIdAvailabilityResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        available: zod.boolean().describe("ID 사용 가능 여부"),
        message: zod.string().describe("상태 메시지"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * Generate encrypted data and crypto token for NICE module initialization
 * @summary Initialize NICE authentication
 */
export const niceAuthControllerInitializeAuthHeader = zod
  .object({
    origin: zod.string(),
  })
  .strict();

export const niceAuthControllerInitializeAuthBody = zod
  .object({
    context: zod.enum(["signup", "reauthentication"]).describe("인증 컨텍스트"),
  })
  .strict();

export const niceAuthControllerInitializeAuthResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        tokenVersionId: zod.string().describe("토큰 버전 ID"),
        encData: zod.string().describe("암호화된 데이터"),
        integrityValue: zod.string().describe("무결성 검증값"),
        requestNo: zod.string().optional().describe("요청 번호"),
        context: zod
          .enum(["signup", "reauthentication"])
          .describe("인증 컨텍스트"),
        testMode: zod
          .boolean()
          .optional()
          .describe(
            "본인인증 시험 모드 여부(시험 서버 전용, 운영에서는 오지 않음)",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * Handle NICE callback response, decrypt personal data, and store verification result
 * @summary Process NICE authentication callback
 */
export const niceAuthControllerProcessCallbackBody = zod
  .object({
    encData: zod.string().describe("암호화된 응답 데이터"),
    integrityValue: zod.string().describe("무결성 검증값"),
    context: zod.enum(["signup", "reauthentication"]).describe("인증 컨텍스트"),
    tokenVersionId: zod.string().optional().describe("토큰 버전 ID"),
  })
  .strict();

export const niceAuthControllerProcessCallbackResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        requestNo: zod.string().describe("요청 번호"),
        ciHash: zod.string().describe("CI 해시"),
        diHash: zod.string().describe("DI 해시"),
        isCompleted: zod.boolean().describe("인증 완료 여부"),
        verifiedAt: zod.string().nullable().describe("인증 완료 시각"),
        personalData: zod
          .object({
            name: zod.string().describe("성명"),
            phone: zod.string().describe("휴대폰 번호 (하이픈 제거)"),
            birthDate: zod.string().describe("생년월일 (YYYYMMDD)"),
            gender: zod.enum(["M", "F"]).describe("성별"),
          })
          .strict()
          .optional()
          .describe("개인정보"),
        message: zod.string().optional().describe("메시지"),
        context: zod
          .enum(["signup", "reauthentication"])
          .describe("인증 컨텍스트"),
        testMode: zod
          .boolean()
          .optional()
          .describe("본인인증 시험 모드로 만든 기록이면 true(시험 서버 전용)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 시험 서버(NICE_TEST_MODE=true, 운영 아님)면 true — 화면은 [본인인증] 에서 실제 PASS 대신 시험용 창을 연다. 운영에서는 늘 false.
 * @summary 본인인증 시험 모드 여부
 */
export const niceAuthControllerGetAuthModeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        testMode: zod
          .boolean()
          .describe(
            "본인인증 시험 모드 여부 — true 면 [본인인증] 이 실제 PASS 대신 시험용 창을 연다(시험 서버 전용)",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 시험용 본인인증 창에서 넣은 값으로 NICE 완료 기록과 같은 기록을 남긴다. 시험 모드가 아니면 404.
 * @summary 본인인증 시험 모드 완료(시험 서버 전용)
 */
export const niceAuthControllerCompleteTestVerificationBody = zod
  .object({
    tokenVersionId: zod
      .string()
      .describe("시험 모드 시작 때 받은 1회용 표(tokenVersionId)"),
    context: zod.enum(["signup", "reauthentication"]).describe("인증 컨텍스트"),
    name: zod.string().describe("이름"),
    birthDate: zod.string().describe("생년월일(YYYYMMDD)"),
    gender: zod.enum(["M", "F"]).describe("성별"),
    phone: zod.string().describe("휴대폰 번호"),
  })
  .strict();

export const niceAuthControllerCompleteTestVerificationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        requestNo: zod.string().describe("요청 번호"),
        ciHash: zod.string().describe("CI 해시"),
        diHash: zod.string().describe("DI 해시"),
        isCompleted: zod.boolean().describe("인증 완료 여부"),
        verifiedAt: zod.string().nullable().describe("인증 완료 시각"),
        personalData: zod
          .object({
            name: zod.string().describe("성명"),
            phone: zod.string().describe("휴대폰 번호 (하이픈 제거)"),
            birthDate: zod.string().describe("생년월일 (YYYYMMDD)"),
            gender: zod.enum(["M", "F"]).describe("성별"),
          })
          .strict()
          .optional()
          .describe("개인정보"),
        message: zod.string().optional().describe("메시지"),
        context: zod
          .enum(["signup", "reauthentication"])
          .describe("인증 컨텍스트"),
        testMode: zod
          .boolean()
          .optional()
          .describe("본인인증 시험 모드로 만든 기록이면 true(시험 서버 전용)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * NICE POST 콜백을 서버에서 받아 프론트엔드 콜백 페이지로 302 리다이렉트합니다. cross-origin/CSP 제약을 받는 인라인 HTML 핸드오프를 대체합니다.
 * @summary NICE 콜백 브릿지 (POST → 프론트 콜백 302 리다이렉트)
 */
export const niceAuthControllerBridgeNiceCallbackQueryParams = zod
  .object({
    context: zod.coerce.string(),
  })
  .strict();

/**
 * NICE가 GET 리다이렉트로 복귀하는 흐름(모바일 PASS 앱)에서 암호화 페이로드가 쿼리스트링으로 전달되는 경우를 처리합니다.
 * @summary NICE 콜백 브릿지 (GET 리다이렉트 복귀 경로)
 */
export const niceAuthControllerBridgeNiceCallbackGetQueryParams = zod
  .object({
    context: zod.coerce.string(),
  })
  .strict();
